import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatsQueryServices } from "../../qrtk/services/stats/stats.qrtk";
import { IStatsResponse } from "../../qrtk/services/stats/responses/stats.response";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";

// Types para el estado de stats
export interface IStatsState {
  countDrafts: number;
}

// Estado inicial
const initialState: IStatsState = {
  countDrafts: 0
};

// Slice de Redux para estadísticas
export const StatsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    resetStats: state => initialState,
    updateStatsData: (state, action: PayloadAction<IStatsResponse>) => {
      state.countDrafts = action.payload.data.property_draft_count || 0;
    }
  },
  extraReducers: builder => {
    builder
      .addMatcher(StatsQueryServices.endpoints.stats.matchPending, state => {
        state.countDrafts = 0;
      })
      .addMatcher(
        StatsQueryServices.endpoints.stats.matchFulfilled,
        (state, action) => {
          state.countDrafts = action.payload.data.property_draft_count || 0;
        }
      )
      .addMatcher(
        StatsQueryServices.endpoints.stats.matchRejected,
        (state, action) => {
          state.countDrafts = 0;
        }
      );
  }
});

// Exportar acciones
export const { resetStats, updateStatsData } = StatsSlice.actions;

export const useStatsSlice = () => {
  const dispatch = useDispatch();
  const stats = useSelector((state: RootState) => state.stats);

  const handleResetStats = useCallback(() => {
    dispatch(resetStats());
  }, [dispatch]);

  const handleUpdateStatsData = useCallback(
    (statsData: IStatsResponse) => {
      dispatch(updateStatsData(statsData));
    },
    [dispatch]
  );

  return {
    stats: stats as unknown as IStatsState,
    dispatch,
    handleResetStats,
    handleUpdateStatsData
  };
};

// Exportar el reducer
export default StatsSlice.reducer;
